export enum EventType {
  LOCATION = 'location',
  VISIT = 'visit',
}
